// Module
var code = `<div ng-if="\$ctrl.loan">

  <div class="tab-menu">
    <ul class="nav-tabs">
      <li class="active"><a data-target="#amortization-preview-tab" data-toggle="tab">
        <span>Amortization schedule</span>
      </a></li>
      <li ng-if="\$ctrl.loan.uidLedger"><a data-target="#uid-ledger-preview-tab" data-toggle="tab">
        <span>UID Ledger</span>
      </a></li>
      <li ng-if="\$ctrl.loan.discountChargesLedger">
        <a data-target="#discount-charges-ledger-preview-tab"
           data-toggle="tab">
          <span>Discount Charges Ledger</span>
        </a></li>
    </ul>
  </div>

  <div class="tab-content" style="overflow: unset">
    <div class="tab-pane active" id="amortization-preview-tab">
      <amortization-preview
          amortization-preview="\$ctrl.loan.amortizationSchedule">
      </amortization-preview>
    </div>

    <div class="tab-pane" id="uid-ledger-preview-tab" ng-if="\$ctrl.loan.uidLedger">
      <div>
        <uid-ledger
            uid-ledger="\$ctrl.loan.uidLedger">
        </uid-ledger>
      </div>
    </div>

    <div class="tab-pane" id="discount-charges-ledger-preview-tab">
      <div>
        <discount-charges-ledger
            discount-charges="\$ctrl.loan.discountChargesLedger">
        </discount-charges-ledger>
      </div>
    </div>
  </div>

  <div>
    <table class="table">
      <tr>
        <td>Term:</td>
        <td>
          <div class="glued-input flex">
            <glue-container append="'days'">
              <input disabled
                     type="text"
                     ng-value="\$ctrl.loan.term + (\$ctrl.loan.termAdjustment > 0 ? ' (+' + \$ctrl.loan.termAdjustment + ')' : '')"/>
            </glue-container>
          </div>
        </td>
      </tr>
      <tr>
        <td>Calendar days:</td>
        <td>
          <div class="glued-input flex">
            <glue-container append="'days'">
              <input disabled
                     type="text"
                     ng-value="\$ctrl.getCalendarDays() + (\$ctrl.loan.termAdjustment > 0 ? ' (+' + \$ctrl.loan.termAdjustment + ')' : '')"/>
            </glue-container>
          </div>
        </td>
      </tr>
      <tr>
        <td>Principal:</td>
        <td>
          <cash value="\$ctrl.loan.principalAmount"
                ng-disabled="true"></cash>
        </td>
      </tr>
      <tr ng-if="\$ctrl.loanType.collectAdvanceInterest">
        <td>Advance interest:</td>
        <td>
          <div class="glued-input flex">
            <cash value="\$ctrl.loan.advanceInterestAmount"
                  ng-disabled="true"></cash>
          </div>
        </td>
      </tr>

      <tr>
        <td>Charges and fees:</td>
        <td>
          <div class="glued-input flex">
            <cash value="\$ctrl.calculateChargesAndFees()"
                  ng-disabled="true">
            </cash>
          </div>
        </td>
      </tr>

      <tr ng-if="\$ctrl.isRenewedLoan()">
        <td>Renewed loan total balance:</td>
        <td>
          <div class="glued-input flex">
            <cash value="\$ctrl.loan.renewedFromRemainingBalance"
                  ng-disabled="true">
            </cash>
          </div>
        </td>
      </tr>

      <tr ng-if="!\$ctrl.isConsolidatedLoan()">
        <td>Release amount:</td>
        <td>
          <div class="glued-input flex">
            <cash value="\$ctrl.loan.releaseAmount"
                  ng-disabled="true"></cash>
          </div>
        </td>
      </tr>

      <tr ng-if="\$ctrl.isConsolidatedLoan()">
        <td>Total outstanding balance:</td>
        <td>
          <div class="glued-input flex">
            <cash value="\$ctrl.loan.remadeLoanBalance"
                  ng-disabled="true">
            </cash>
          </div>
        </td>
      </tr>
      <tr ng-if="\$ctrl.isConsolidatedLoan()">
        <td>Release amount:</td>
        <td>
          <div class="glued-input flex">
            <cash value="\$ctrl.calculateRemadeReleaseAmount()" ng-disabled="true">
            </cash>
          </div>
        </td>
      </tr>
      <tr ng-if="\$ctrl.isRestructuredLoan()">
        <td>Restructured loan total amount:</td>
        <td>
          <div class="glued-input flex">
            <cash value="\$ctrl.waiveRequest.total.totalFinalBalanceToPay"
                  ng-disabled="true">
            </cash>
          </div>
        </td>
      </tr>
      <tr ng-if="\$ctrl.isRestructuredLoan()">
        <td>Excessive amount:</td>
        <td>
          <div class="glued-input flex">
            <cash value="\$ctrl.calculateExcessiveAmount()"
                  ng-disabled="true">
            </cash>
            <help title="Excessive amount will be used as a payment for the new loan."></help>
          </div>
        </td>
      </tr>
      <tr>
        <td>Effective interest rate (periodic):</td>
        <td>
          <div class="glued-input flex">
            <glue-container append-percentage="true">
              <input disabled
                     type="text"
                     ng-value="\$ctrl.loan.eirPeriodic"/>
            </glue-container>
          </div>
        </td>
      </tr>
      <tr ng-if="\$ctrl.loan.paymentIntervalDefinition.basePaymentInterval !== 'DAY'">
        <td>Effective interest rate (monthly):</td>
        <td>
          <div class="glued-input flex">
            <glue-container append-percentage="true">
              <input disabled
                     type="text"
                     ng-value="\$ctrl.loan.eirMonthly"/>
            </glue-container>
          </div>
        </td>
      </tr>
      <tr>
        <td>Effective interest rate (annual):</td>
        <td>
          <div class="glued-input flex">
            <glue-container append-percentage="true">
              <input disabled
                     type="text"
                     ng-value="\$ctrl.loan.eirAnnual"/>
            </glue-container>
          </div>
        </td>
      </tr>
      <tr ng-if="\$ctrl.loan.interestType === 'ADD_ON_RATE'">
        <td>Gross effective interest rate (periodic):</td>
        <td>
          <div class="glued-input flex">
            <glue-container append-percentage="true">
              <input disabled
                     type="text"
                     ng-value="\$ctrl.loan.grossEirPeriodic"/>
            </glue-container>
          </div>
        </td>
      </tr>

      <tr ng-if="\$ctrl.loan.interestType === 'ADD_ON_RATE'">
        <td>Gross effective interest rate (annual):</td>
        <td>
          <div class="glued-input flex">
            <glue-container append-percentage="true">
              <input disabled
                     type="text"
                     ng-value="\$ctrl.loan.grossEirAnnual"/>
            </glue-container>
          </div>
        </td>
      </tr>


      <tr ng-if="\$ctrl.loan.interestType === 'ADD_ON_RATE'">
        <td>Add-on rate (periodic):</td>
        <td>
          <div class="glued-input flex">
            <glue-container append-percentage="true">
              <input disabled
                     type="text"
                     ng-value="\$ctrl.loan.intervalInterestRate"/>
            </glue-container>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/preview/loan-preview.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;